import { render } from "./PurchaseOrderApprovalList.vue?vue&type=template&id=241218c8&scoped=true"
import script from "./PurchaseOrderApprovalList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderApprovalList.vue?vue&type=script&lang=js"

import "./PurchaseOrderApprovalList.vue?vue&type=style&index=0&id=241218c8&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241218c8"]])

export default __exports__